var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApartmentsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 93,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5F5C60",
    d: "M53.068 21.662V20.25h33.863v1.41M4.668 4.073v-1.41h47.744v1.41"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#5F5C60",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.39,
    d: "M.695 91.737h89V86.55h-89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.158 30.813h5.385V23.26h-5.385v7.554zm0 16.425h5.385v-7.552h-5.385v7.552zm0 16.426h5.385v-7.552h-5.385v7.552zm0 16.428h5.385v-7.554h-5.385v7.554zM25.582 30.813h5.383V23.26h-5.383v7.554zm0 16.425h5.383v-7.552h-5.383v7.552zm0 16.426h5.383v-7.552h-5.383v7.552zm0 16.428h5.383v-7.554h-5.383v7.554zM11.004 30.813h5.384V23.26h-5.384v7.554zM40.158 14.89h5.385V7.337h-5.385v7.552zm-14.576 0h5.383V7.337h-5.383v7.552zm-14.578 0h5.384V7.337h-5.384v7.552zm0 32.35h5.384v-7.553h-5.384v7.552zm0 16.425h5.384v-7.552h-5.384v7.552zm0 16.428h5.384v-7.554h-5.384v7.554zm41.618 6.224h33.853V18.448H52.622v67.868zm-48.646 0H52.57V.737H3.976v85.58z",
    strokeWidth: 1.475
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5C60",
    strokeWidth: 1.475,
    strokeLinejoin: "round",
    d: "M59.65 81.568h5.384v-7.554H59.65zM59.65 65.14h5.384v-7.552H59.65zM59.65 48.714h5.384v-7.553H59.65zM59.65 32.29h5.384v-7.555H59.65zM74.228 81.568h5.383v-7.554h-5.383zM74.228 65.14h5.383v-7.552h-5.383zM74.228 48.714h5.383v-7.553h-5.383zM74.228 32.29h5.383v-7.555h-5.383z"
  }))));
}

export default SvgApartmentsIcon;